import { useState, useRef, useEffect } from 'react';
import { getDayFromCode } from '../Constant/constants';
import { ref, uploadBytes, getDownloadURL, deleteObject } from 'firebase/storage';
import { doc, setDoc, collection, getDoc, getDocs, deleteDoc } from 'firebase/firestore';
import { useParams } from 'react-router-dom';
import RestaurantPreview from './RestaurantPreview';
import HorizontalOptions from './HorizontalOptions';
import EditContact from './Editor/EditContact';
import EditSchedule from './Editor/EditSchedule';
import EditZone from './Editor/EditZone';
import Dish from './Dish';
import EditDish from './Editor/EditDish';
import Select from 'react-select';
import noPicture from './Editor/images/no_picture.jpg';
import { dishStyles, cookingTypes } from '../Constant/constants';
import { 
    MdAddPhotoAlternate, MdDelete, MdModeEditOutline,
    MdAddIcCall, MdAddAlarm, MdAddBusiness, MdKeyboardBackspace
} from 'react-icons/md';

const pickerFilter = ['.jpg','.png','.jpeg'];

const RestaurantEditor = (props) => {

    const coverPicker = useRef(null);

    /* New/Edit Restaurant Variables */

    const { resID } = useParams();
    const [isNew, toggleNew] = useState(props.new);
    const [resName, setResName] = useState("");
    const [resLegend, setResLegend] = useState("");
    const [resFront, setResFront] = useState("");
    const [newFront, setNewFront] = useState();
    const [resLogo, setResLogo] = useState("");
    const [newLogo, setNewLogo] = useState();
    const [resCover, setResCover] = useState("");
    const [newCover, setNewCover] = useState();
    const [resDescription, setDescription] = useState("");
    const [resTags, setTags] = useState("");

    const [cookingType, setCookingType] = useState(cookingTypes[0]);
    const cookingTypeRef = useRef(null);

    const [currentLocation, setLocation] = useState();

    const [contacts, setContacts] = useState();
    const [schedules, setSchedules] = useState();   
    const [dishlist, setDishes] = useState(); 

    const [currentRestaurant, setCurrentRestaurant] = useState(props.currentRestaurant);

    const [saving, setSaving] = useState(false);

    const editCover = () => {
        coverPicker.current.click();
    }

    const handleCoverChange = (e) => {
        let file = e.target.files[0];

        var reader = new FileReader();

        // Callback for read complete
        reader.onload = function(e) {
            setNewCover(e.target.result);
        };

        // Callback for read error
        reader.onerror = function(e) {
        };
        
        reader.readAsDataURL(file);
    }

    const saveCollection = (collectionName, id, label, content) => {
        let updatePack = {};
        updatePack[label] = content;

        const resRef = doc(props.eDB, `Restaurants/${resID}/${collectionName}/${id}`);
        setDoc(resRef, updatePack, {})
        .then((_) => {
            console.log("Values applied to eDB");
        });
    }

    const saveLocation = (content, index) => {
        if(index){
            const scheduleRef = doc(props.eDB, `Restaurants/${resID}/Schedules/${index}`);
            const contactRef = doc(props.eDB, `Restaurants/${resID}/Contacts/${index}`);
            deleteDoc(scheduleRef);
            deleteDoc(contactRef);
        }

        const resRef = doc(props.eDB, `Restaurants/${resID}`);
        setDoc(resRef, content, { merge: true })
        .then((_) => {
            console.log("Values applied to eDB");
        });
    }

    const addDish = () => {
        if(currentRestaurant){
            props.callback.showPopup('Agregar Platillo', <EditDish resID={resID} eDB={props.eDB} storage={props.storage} dishlist={dishlist} setDishlist={setDishes} close={props.callback.closePopup} new/>);
        }else{
            window.alert('Necesitas guardar el restaurante primero.');
        }
    }

    const addZone = () => {
        if(currentRestaurant){
            props.callback.showPopup('Agregar Ubicacion', <EditZone locations={currentRestaurant.location} setRestaurant={setCurrentRestaurant} setLocation={setLocation} export={saveLocation} close={props.callback.closePopup}/>);
        }else{
            window.alert('Necesitas guardar el restaurante primero');
        }
    }

    const editZone = () => {
        props.callback.showPopup('Editar Ubicacion', <EditZone location={currentLocation} locations={currentRestaurant.location} setRestaurant={setCurrentRestaurant} setLocation={setLocation} export={saveLocation} close={props.callback.closePopup} edit/>);
    }

    const deleteZone = () => {
        props.callback.showPopup('Eliminar Ubicacion', <EditZone location={currentLocation} locations={currentRestaurant.location} setRestaurant={setCurrentRestaurant} export={saveLocation} close={props.callback.closePopup} delete/>);
    }

    const addContact = () => {
        const contactsPos = currentRestaurant.location.indexOf(currentLocation);
        props.callback.showPopup('Agregar Contacto', <EditContact contactsPos={contactsPos} contacts={contacts} setContacts={setContacts} export={saveCollection} close={props.callback.closePopup} new/>);
    }

    const editContact = (contact) => {
        const contactsPos = currentRestaurant.location.indexOf(currentLocation);
        const contactPos = contacts[contactsPos].indexOf(contact);
        props.callback.showPopup('Editar Contacto', <EditContact contactsPos={contactsPos} contactPos={contactPos}  contacts={contacts} setContacts={setContacts} contact={contact} export={saveCollection} close={props.callback.closePopup}  />);
    }

    const deleteContact = (contact) => {
        const contactsPos = currentRestaurant.location.indexOf(currentLocation);
        const contactPos = contacts[contactsPos].indexOf(contact);
        props.callback.showPopup('Eliminar Contacto', <EditContact contactsPos={contactsPos} contactPos={contactPos}  contacts={contacts} setContacts={setContacts} contact={contact} export={saveCollection} close={props.callback.closePopup} delete  />);
    }

    const addSchedule = () => {
        const schedulesPos = currentRestaurant.location.indexOf(currentLocation);
        props.callback.showPopup('Agregar Horario', <EditSchedule schedulesPos={schedulesPos} schedules={schedules} setSchedules={setSchedules} export={saveCollection} close={props.callback.closePopup} new />);
    }

    const editSchedule = (schedule) => {
        const schedulesPos = currentRestaurant.location.indexOf(currentLocation);
        const schedulePos = schedules[schedulesPos].indexOf(schedule);
        props.callback.showPopup('Editar Horario', <EditSchedule schedulesPos={schedulesPos} schedulePos={schedulePos}  schedules={schedules} setSchedules={setSchedules} schedule={schedule} export={saveCollection} close={props.callback.closePopup} />);
    }

    const deleteSchedule = (schedule) => {
        const schedulesPos = currentRestaurant.location.indexOf(currentLocation);
        props.callback.showPopup('Borrar Horario', <EditSchedule schedulesPos={schedulesPos} schedules={schedules} setSchedules={setSchedules} schedule={schedule} export={saveCollection} close={props.callback.closePopup} delete/>);
    }

    const verify = () => {
        if(isNew){
            if(!newFront){
                window.alert('Agrega una foto de presentacion');
                return false;
            }

            if(!newLogo){
                window.alert('Agrega una logotipo');
                return false;
            }

            if(!newCover){
                window.alert('Agrega una foto de portada');
                return false;
            }
        }

        if(resName.trim().length === 0){
            window.alert('Agrega un nombre valido.');
            return false;
        }

        if(resLegend.trim().length === 0){
            window.alert('Agrega una legenda valida.');
            return false;
        }

        if(resTags.length === 0){
            window.alert('Agrega al menos una etiqueta.');
            return false;
        }

        return true;
    }

    const save = async () => {

        if(!verify()){
            setSaving(false);
            return;
        }

        let updatePack = {
            cookingStyle: cookingType.code,
            name: resName,
            legend: resLegend,
            dishStyle: resTags.map((t) => { return t.value; }),
            summary: resDescription,
            logo: isNew?'':currentRestaurant.logo,
            frontPic: isNew?'':currentRestaurant.frontPic,
            cover: isNew?'':currentRestaurant.cover
        }

        // Did Picture Change?
        if(newFront){
            // Ref to new picture
            updatePack.frontPic = Date.now().toString();
            const stoRef = ref(props.storage, `Restaurants/${resID}/${updatePack.frontPic}`);
            
            const blobFrom = await fetch(newFront);
            const result = await blobFrom.blob();

            await uploadBytes(stoRef, result);

            // Ref to current picture
            if(!isNew){
                let currentFrontRef = ref(props.storage, `Restaurants/${resID}/${currentRestaurant.frontPic}`);

                deleteObject(currentFrontRef).catch((error) => {
                    console.log("Error deleting, doesn't exists?");
                });
            }
        }

        if(newLogo){
            // Ref to new picture
            updatePack.logo = Date.now().toString();
            const stoRef = ref(props.storage, `Restaurants/${resID}/${updatePack.logo}`);
            
            const blobFrom = await fetch(newLogo);
            const result = await blobFrom.blob();

            await uploadBytes(stoRef, result);

            // Ref to current picture
            if(!isNew){
                let currentLogoRef = ref(props.storage, `Restaurants/${resID}/${currentRestaurant.logo}`);
            
                deleteObject(currentLogoRef).catch((error) => {
                    console.log("Error deleting, doesn't exists?");
                });
            }
        }

        if(newCover){
            // Ref to new picture
            updatePack.cover = Date.now().toString();
            const stoRef = ref(props.storage, `Restaurants/${resID}/${updatePack.cover}`);
            
            const blobFrom = await fetch(newCover);
            const result = await blobFrom.blob();

            await uploadBytes(stoRef, result);


            // Ref to current picture
            if(!isNew){
                let currentCoverRef = ref(props.storage, `Restaurants/${currentRestaurant.id}/${currentRestaurant.cover}`);

                deleteObject(currentCoverRef).catch((error) => {
                    console.log("Error deleting, doesn't exists?");
                });
            }
        }

        if(compareRestaurant(currentRestaurant, updatePack)){
            if(isNew) updatePack.location = [];
            const resRef = doc(props.eDB, 'Restaurants', resID);
            await setDoc(resRef, updatePack, { merge: true});

            setCurrentRestaurant({...currentRestaurant,...updatePack, id: resID});

            if(isNew){
                setNewCover(undefined);
                setNewLogo(undefined);
                setNewFront(undefined);
                toggleNew(false);
                props.router(`Edit/${resID}`, {replace: true});
            }
        }

        setSaving(false);
    }

    const compareRestaurant = (originalRes, newRes) => {
        if(isNew) return true;
        if(newFront || newCover || newLogo ) return true;
        if(originalRes.name !== newRes.name) return true;
        if(originalRes.legend !== newRes.legend) return true;
        if(originalRes.summary !== newRes.summary) return true;
        if(originalRes.cookingStyle !== newRes.cookingStyle) return true;
        if(originalRes.dishStyle.length !== newRes.dishStyle.length){
            return true;
        }else{
            for(let d of originalRes.dishStyle){
                const i = newRes.dishStyle.findIndex((nd) =>{
                    return nd === d;
                });

                if(i === -1) return true;
            }
        }        
        return false;
    }

    useEffect(() => {
        return () => {
            props.callback.closePopup();
        }
    }, [] );

    useEffect(() => {
        if(!currentRestaurant){
            if(!isNew){
                const resRef = doc(props.eDB, 'Restaurants',resID);
                getDoc(resRef).then((docInfo) => {
                    if(docInfo.exists()){
                        setCurrentRestaurant({...docInfo.data(),id: docInfo.id});
                    }
                });
            }
        }else{
            setResName(currentRestaurant.name);
            setResLegend(currentRestaurant.legend);
            setDescription(currentRestaurant.summary);

            // Set Tags
            let tags = currentRestaurant.dishStyle.map((ds) => {
                const i = dishStyles.findIndex((d) => { return d.value === ds; });
                return { label: dishStyles[i].label, value: ds };
            })
            setTags(tags);
            
            const currentStyle = cookingTypes.find((style) => style.code === currentRestaurant.cookingStyle);
            cookingTypeRef.current.selectedIndex = cookingTypes.indexOf(currentStyle);            
            setCookingType(currentStyle);

            if(currentRestaurant.location){
                setLocation(currentRestaurant.location[0]);
            }

            //Load Schedules
            getDocs(collection(props.eDB, 'Restaurants', resID, 'Schedules'))
            .then((querySnapshot) => {
                let scheduleList = [];
                querySnapshot.forEach((doc) => {
                    let thisSchedule = [];
                    doc.data().schedules.forEach((contact) => {
                        thisSchedule.push(contact);
                    });
                    scheduleList[doc.id] = thisSchedule;
                });
                setSchedules(scheduleList);
            });

            //Load Contacts
            getDocs(collection(props.eDB, 'Restaurants', resID, 'Contacts'))
            .then((querySnapshot) => {
                let contactList = [];
                querySnapshot.forEach((doc) => {
                    let thisContacts = [];
                    doc.data().contacts.forEach((contact) => {
                        thisContacts.push(contact);
                    });
                    contactList[doc.id] = thisContacts;
                });
                setContacts(contactList);
            });
            
            // Get Current Front
            const frontRef = ref(props.storage, `Restaurants/${resID}/${currentRestaurant.frontPic}`);
            
            getDownloadURL(frontRef).then((url) => {
                setResFront(url);
            }).catch((_) => {
                console.log("Unable to get the photoURL");
            });

            // Get Current Logo
            const logoRef = ref(props.storage, `Restaurants/${resID}/${currentRestaurant.logo}`);
            
            getDownloadURL(logoRef).then((url) => {
                setResLogo(url);
            }).catch((_) => {
                console.log("Unable to get the photoURL");
            });

            // Get Current Cover
            const coverRef = ref(props.storage, `Restaurants/${resID}/${currentRestaurant.cover}`);
            
            getDownloadURL(coverRef).then((url) => {
                setResCover(url);
            }).catch((_) => {
                console.log("Unable to get the photoURL");
            });

            // Load Dishes
            getDocs(collection(props.eDB, 'Restaurants', resID, 'Dishes'))
            .then((querySnapshot) => {
                let newDishList =  [];
                querySnapshot.forEach((doc) => {
                    let dish = doc.data();
                        dish.id = doc.id;
                    newDishList.push(dish);
                });
                setDishes(newDishList);
            });

        }
    }, [currentRestaurant, isNew, props.eDB, props.storage, resID]);

    return(
        <>
            <div className='fitHeight'>
                <div className='title d-flex tx-white'><button onClick={() => props.router(-1)} style={{border: '0', background: 'none', cursor: 'pointer'}}><MdKeyboardBackspace size='1.5rem' color='white'/></button>{isNew?'Nuevo Restaurante':'Editar Restaurante'}</div>
                <div className='ContentContainer mt-2 bg-rounded bg-container no-scroll'>
                    <div className='title pb-1 tx-white'>
                        Informacion Basica
                    </div>
                    <div className='d-grid col-md-sm'>
                        <div>
                            <RestaurantPreview name={resName} legend={resLegend} front={{current: resFront, new: newFront}} setFront={setNewFront} logo={{current:resLogo,new: newLogo}} setLogo={setNewLogo} />
                        </div>

                        <div className='pt-2'>
                            <div>
                                <div className='tx-white'>Nombre</div>
                                <div><input type='text' value={resName} onChange={(e) => setResName(e.target.value)}/></div>
                            </div>
                            <br/>
                            <div>
                                <div className='tx-white'>Legend</div>
                                <div><input type='text' value={resLegend} onChange={(e) => setResLegend(e.target.value)}/></div>
                            </div>
                        </div>

                        <div className='m-auto CoverBox mt-2'>
                            <div className='CoverEditor LTRborder'>
                                <div style={{position: 'relative', width: '100%', height: '100%'}}>
                                    <div className='CoverEditor' style={{position: 'absolute'}}>
                                        <img src={newCover?newCover:(resCover?resCover:noPicture)} width='100%' alt='Portada'/>
                                    </div>

                                    <div className='CoverEditor' style={{position: 'absolute', background: "linear-gradient(0deg, rgba(0,0,0,1) 0%, rgba(0,0,0,0.9) 2%, rgba(255,255,255,0) 50%)"}}></div>
                                    
                                    <div className='EditTools'>
                                        <button style={{display: newCover ? 'none':'block'}} onClick={() => editCover()} className="cbtn"><MdModeEditOutline size='1rem' pointerEvents='none'/></button>
                                        <button style={{display: newCover ? 'block':'none'}} onClick={() => {coverPicker.current.value = '';setNewCover(undefined);}} className="cbtn"><MdDelete size='1rem' pointerEvents='none'/></button>
                                        <input className='d-none' type='file' accept={pickerFilter} ref={coverPicker} onChange={handleCoverChange} />
                                    </div>

                                    <div style={{position: 'absolute', bottom: '0', left: '0', margin: '0.5rem'}}>
                                        <div className='mt-5'>
                                            <img className="Logo" src={newLogo?newLogo:(resLogo?resLogo:noPicture)} alt='logo'/>
                                        </div>
                                        <div>
                                            <span className='title tx-white'><strong>{resName}</strong></span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='bg-black tx-white px-1 pb-1'>
                                <div><small>Comida {cookingType.name}</small></div>
                                <div className='pt-1'>
                                    <pre className='no-scroll' style={{whiteSpace: 'pre-line', maxHeight: '12rem', overflow: 'auto'}}>{resDescription}</pre>
                                </div>
                            </div>
                        </div>
                        

                        <div className='pt-2'>
                            <div>
                                <div className='tx-white'>Tipo de Cocina</div>
                                <select style={{width: '90%'}} className='mt-1 p-1' onChange={(e) => setCookingType(cookingTypes[e.target.selectedIndex])} ref={cookingTypeRef}>
                                    {
                                        cookingTypes.map((type) => {
                                            return <option key={type.code} value={type.code}>{type.name}</option>
                                        })                                    
                                    }
                                </select>
                            </div>
                            <br/>
                            <div>
                                <div className='tx-white'>Descripcion</div>
                                <div><textarea style={{width: '90%', minHeight: '11rem'}} type='text' value={resDescription} onChange={(e) => setDescription(e.target.value)}></textarea></div>
                                <br/>
                                <div className='tx-white'>Etiquetas</div>
                                <div style={{width: '90%'}}>
                                    <Select
                                        isMulti
                                        value={resTags}
                                        onChange={setTags}
                                        options={dishStyles}
                                        placeholder='Elije las etiquetas'  
                                    />
                                    <br/>
                                    <div>
                                        <button className='m-auto btn btn-info' onClick={() => {currentRestaurant?props.router(`Edit/${resID}/Menu`):window.alert('Guarda el restaurante primero.')}}>Ver Menu</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div className='title pt-3 pb-2 d-flex tx-white'>
                        Galeria
                        &nbsp;&nbsp;
                        <div className='d-inline-block d-flex flex-center'>
                            <button onClick={addDish} className='cbtn-md-add d-inline-block mx-1'>
                                <MdAddPhotoAlternate size='1rem' pointerEvents='none' />
                            </button><span className='btn-label'>Agregar</span>
                        </div>
                    </div>
                    <div style={{display: dishlist && dishlist.length > 0 ? 'flex':'none'}} className='gallery-container'>
                        {
                            dishlist && dishlist.map((dish) => {
                                return <Dish key={dish.id} resID={resID} data={dish} callback={props.callback} setDishList={setDishes} dishlist={dishlist} storage={props.storage} eDB={props.eDB} />;
                            })
                        }
                    </div>
                    <br/>

                    <div className='title pb-1 d-flex tx-white'>
                        Contacto
                        &nbsp;&nbsp;
                        <div className='d-inline-block d-flex flex-center'>
                            <button onClick={addZone} className='cbtn-md-add d-inline-block mx-1'>
                                <MdAddBusiness size='1rem' pointerEvents='none' />
                            </button><span className='btn-label'>Agregar</span>
                        </div>
                    </div>               

                    <div className='d-grid'>
                        <div className='horizontalOverflow'>
                            <HorizontalOptions callback={setLocation} current={currentLocation} list={currentRestaurant ? currentRestaurant.location:[] } />
                        </div>
                    </div>

                    <div className='d-grid col-md-sm pt-2 pb-1'>
                        <div>
                            <div className='subtitle d-flex tx-white'>
                                Horarios
                                &nbsp;&nbsp;
                                {
                                    currentLocation && 
                                    <div className='d-inline-block d-flex flex-center'>
                                        <button onClick={addSchedule} className='cbtn-md-add d-inline-block mx-1'>
                                            <MdAddAlarm size='1rem' pointerEvents='none' />
                                        </button><span className='btn-label'>Agregar</span>
                                    </div>
                                }
                            </div>
                            <ul className='pl-3 tx-white'>
                                {
                                    schedules && schedules[currentRestaurant.location.indexOf(currentLocation)] && schedules[currentRestaurant.location.indexOf(currentLocation)].map((s,i) => {
                                    return <li key={i} className='pb-1'>
                                        <strong>
                                            {s.startDay === s.endDay ? getDayFromCode(s.startDay): getDayFromCode(s.startDay)+' a '+getDayFromCode(s.endDay)}: 
                                        </strong> 
                                        &nbsp;&nbsp;{ s.isOff ? 'Cerrado': s.startHour+' - '+s.endHour}
                                        <button onClick={() => editSchedule(s)} className='cbtn-md d-inline-block mx-1'>
                                            <MdModeEditOutline />
                                        </button>
                                        <button onClick={() => deleteSchedule(s)} className='cbtn-md d-inline-block'>
                                            <MdDelete pointerEvents='none' />
                                        </button>
                                    </li>;
                                    })
                                }
                            </ul>
                        </div>

                        <div>
                            <div className='subtitle d-flex tx-white'>
                                Telefonos
                                &nbsp;&nbsp;
                                {
                                    currentLocation && 
                                    <div className='d-inline-block d-flex flex-center'>
                                        <button onClick={addContact} className='cbtn-md-add d-inline-block mx-1'>
                                            <MdAddIcCall size='1rem' pointerEvents='none' />
                                        </button><span className='btn-label'>Agregar</span>
                                    </div>
                                }
                            </div>
                            <ul className='pl-3 tx-white'>
                                {
                                    contacts && contacts[currentRestaurant.location.indexOf(currentLocation)] && contacts[currentRestaurant.location.indexOf(currentLocation)].map((c,i) => {
                                        return <li key={i} className='pb-1'>
                                                <strong>{c.name}: </strong> 
                                                &nbsp;&nbsp;{c.contact}
                                                <button onClick={() => editContact(c)} className='cbtn-md d-inline-block mx-1'>
                                                    <MdModeEditOutline pointerEvents='none' />
                                                </button>
                                                <button onClick={() => deleteContact(c)} className='cbtn-md d-inline-block'>
                                                    <MdDelete pointerEvents='none' />
                                                </button>
                                            </li>;
                                    })
                                }
                            </ul>
                        </div>
                    </div>

                    <div className='subtitle py-1 tx-white'>
                        Ubicacion
                        &nbsp;
                        &nbsp;&nbsp;
                        {
                            currentLocation &&
                            <button onClick={() => deleteZone()} className='cbtn d-inline-block'>
                                <MdDelete pointerEvents='none' />
                            </button>
                        }
                    </div>

                    <div className='d-grid col-md-sm'>
                        <div>{
                            currentLocation && <></>
                            }
                        </div>
                        <div className='p-2 tx-white'>
                            <div className='subtitle mb-1'>
                                Direccion
                                &nbsp;&nbsp;
                                {
                                    currentLocation &&
                                    <button onClick={() => editZone()} className='cbtn-md d-inline-block mx-1'>
                                        <MdModeEditOutline />
                                    </button>
                                }
                            </div>
                            {currentLocation ? currentLocation.ADDRESS:'Ninguna ubicacion agregada'}
                        </div>
                    </div>

                    <div className='p-2'>
                        <button onClick={() => {setSaving(true);save()}} className='m-auto btn btn-accept' disabled={saving}>
                            {
                                saving?<progress></progress>:'Guardar'
                            }
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
}

export default RestaurantEditor;